(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('PatternInfo', PatternInfo);

    PatternInfo.$inject = ['$resource'];

    function PatternInfo($resource) {
        var resourceUrl = 'api/pattern-infos/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
